import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import { Membership } from 'src/features/users/utils/types';

const RESOURCE = '/parkings/:parkingId/memberships/:membershipId/';

interface DTO {
    parkingId: string;
    membershipId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ membershipId, parkingId }: DTO): Promise<Membership> => {
    return axios.get(formatResourcePath(RESOURCE, { membershipId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_PARKINGS_MEMBERSHIP_RESOURCE, useQueryHook as useGetParkingsMembership };
